export default __webpack_public_path__ + "static/media/TopFingerprinting.8c3bb799.png";